export function useInitials(fullName) {
  let names = fullName.split(" ")
  let initials = names.slice(0, 2).map(name => name.charAt(0).toUpperCase())
  return initials.join("")
}

export function useMakeFilter(value, matchType = "contains") {
  if (!value) {
    return undefined
  }

  return {
    value: value,
    modifiers: { matchType: matchType },
  }
}

export function useUpdateRefVariable(value) {
  if (!value || value === "") {
    return undefined
  }
  return value.value
}

export const camelToStartCase = function (text) {
  const result = text.replace(/([A-Z])/g, " $1")
  return result.charAt(0).toUpperCase() + result.slice(1)
}

export const capitalize = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function useMakeReportFilterFromArray(values) {
  if (!values || values === "") {
    return undefined
  }

  if (!Array.isArray(values) || (Array.isArray(values) && values.length <= 0)) {
    return undefined
  }

  const mappedValues = values.map(value => ({
    id: value,
    label: value,
  }))

  return {
    value: mappedValues,
    modifiers: {
      exclude: false,
    },
  }
}

export function useMakeReportFilter(value, modifiers = { }) {
  if (!value || value === "") {
    return undefined
  }

  if (Array.isArray(value)) {
    return useMakeReportFilterFromArray(value)
  }

  return {
    value: [
      {
        id: value,
        label: value,
      },
    ],
    modifiers: {
      exclude: false,
      ...modifiers,
    },
  }
}
export function useMakeReportFilterById(value) {
  if (!value || value === "") {
    return undefined
  }

  if (!Array.isArray(value)) {
    value = [value]
  }

  return {
    //value: value.map(value=>value.map(value=>({id: value.id }))),
    value: value.map(item => ({ id: item.id })),
    modifiers: {
      exclude: false,
    },
  }
}
